import React from 'react';
import { PrivacyPolicyContainer } from './PrivacyStyles.styles';

const YourRights = () => {
  return (
    <PrivacyPolicyContainer>
      <h3>Your Rights</h3>
      <p>
        Depending on your location, you may have the following rights regarding
        your personal information:
      </p>
      <ul>
        <li>The right to access the personal information we hold about you.</li>
        <li>The right to request corrections or deletions of your data.</li>
        <li>The right to opt out of marketing communications.</li>
        <li>
          The right to data portability, allowing you to request a copy of your
          data.
        </li>
      </ul>
    </PrivacyPolicyContainer>
  );
};

export default YourRights;
